import { getOnZzim } from '@/common/converter/utils/get-event-property'
import { restEventCommonParams } from '@/common/converter/const'

/**
 * convert event 'on-zzim'
 * @param elementList
 * @returns {{add_timestamp: string, method: string, add_common_params: string, add_credential: string, type: string, bodyjson, url}|undefined}
 */
export const convertEventOnZzim = (elementList = []) => {
  const { type, url, method, bodyList, isRender } = getOnZzim(elementList)

  if (!isRender) return undefined

  return {
    type,
    url,
    method,
    bodylist: bodyList,
    ...restEventCommonParams,
  }
}
